import React from "react";

import { ReactComponent as CopyLink } from './copyLink.svg'
import { useClipboard } from './../../../hooks/useClipboard';
import { useCallback } from "react";


const FormTextField = ({
    name,
    touched,
    errors,
    values,
    placeholder,
    handleChange,
    maxLength,
    ...props
}) => {

    const clipBoard = useClipboard()

    const handleChangeValue = useCallback((e) => {
        touched[name] = false;
        return handleChange(e)
    }, [touched, name, handleChange])

    return (
        <>
            <input
                onChange={handleChangeValue}
                maxLength={maxLength}
                name={name}
                value={values[name]}
                placeholder={placeholder}
                autoComplete="off"
                className={props.className}
                ref={clipBoard.target}
            />
            {
                props.isLink && values[name] &&
                <CopyLink
                    className="copy-link"
                    onClick={clipBoard.copy}
                />
            }
        </>
    )
}

export default FormTextField;